export default __webpack_public_path__ + "static/media/mpulse-icon-dark.75715b29.png";